<template>
	<nav class="navbar is-white">
		<notifications group="global" />
		<div class="container">
			<div class="columns">
				<div class="column">
					<div class="navbar-brand text">
						<a class="navbar-item site-name" :href="homeLink">Psychic Portal</a>
						<div class="navbar-burger burger" :class="{'is-active': menuOpen}" @click="$emit('toggle-menu')">
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<script>
	export default {
		props: {
			menuOpen: Boolean,
			home: String
		},
		computed: {
			homeLink() {
				if (this.home === undefined) {
					return "/login"
				}

				return `/${this.home}`
			}
		}
	}
</script>